import React, {useState, useEffect} from 'react';
import Cookies from 'js-cookie';
import CheckMark from "../../assets/Check mark.svg";
import CrossMark from "../../assets/Cross mark.svg";

const translations = {
  en: {
    managementInsights: "Management Insights",
    recommendations: "Recommendations",
    managementStrategies: "Management Strategies",
    onboardingRecommendations: "Onboarding Recommendations",
    dos: "Do's",
    donts: "Don'ts",
    teamFit: "Team Fit",
    bestWorkCulture: "Best Work Culture",
    potentialChallenges: "Potential Challenges",
    developmentPoints: "Development Points",
    interviewFocusAreas: "Interview Focus Areas",
    interviewFocusDescription: "Based on the personality profile, consider exploring these areas during interviews:"
  },
  nl: {
    managementInsights: "Management Inzichten",
    recommendations: "Aanbevelingen",
    managementStrategies: "Management Strategieën",
    onboardingRecommendations: "Onboarding Aanbevelingen",
    dos: "Do's",
    donts: "Don'ts",
    teamFit: "Team Passendheid",
    bestWorkCulture: "Beste Werkcultuur",
    potentialChallenges: "Mogelijke Uitdagingen",
    developmentPoints: "Ontwikkelingspunten",
    interviewFocusAreas: "Interview Focusgebieden",
    interviewFocusDescription: "Op basis van het persoonlijkheidsprofiel, overweeg deze gebieden te verkennen tijdens interviews:"
  }
};

const Recommendations = ({ analysisResults, isRecruiterMode, isDutch = false }) => {
    const [lang, setLang] = useState(isDutch ? 'nl' : 'en');
    const t = translations[lang];

    useEffect(() => {
        const checkLanguage = () => {
            const cookieIsDutch = Cookies.get('isDutch') === 'true';
            const newLang = cookieIsDutch ? 'nl' : 'en';
            if (newLang !== lang) {
                setLang(newLang);
            }
        };
        checkLanguage();
        const interval = setInterval(checkLanguage, 1000);
        return () => clearInterval(interval);
    }, [lang]);

    return (
        <div className="flex flex-col animate-text pb-4">
            <h2 className="text-xl font-bold text-primary">
                {isRecruiterMode ? t.managementInsights : t.recommendations}
            </h2>
            <div className="flex-1 border rounded-md w-full h-fit mt-2 flex flex-col gap-4">
                <div className="flex flex-col gap-4">
                    <div className="grid grid-cols-2 gap-4 p-4">
                        {isRecruiterMode ? (
                            <>
                                <div className="animate-text">
                                    <h3 className="mb-1 font-bold">{t.managementStrategies}</h3>
                                    <ul className="ml-7 list-disc">
                                        {analysisResults.recommendations.managementStrategies?.map((strategy, index) => (
                                            <li key={index}>{strategy}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="animate-text">
                                    <h3 className="mb-1 font-bold">{t.onboardingRecommendations}</h3>
                                    <ul className="ml-7 list-disc">
                                        {analysisResults.recommendations.onboardingTips?.map((tip, index) => (
                                            <li key={index}>{tip}</li>
                                        ))}
                                    </ul>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="animate-text">
                                    <h3 className="mb-1 font-bold flex items-center gap-2">
                                        <span className="text-green-500 text-sm">
                                            <img src={CheckMark} alt="check" className="w-4 h-4 mb-neg" />
                                        </span> {t.dos}:
                                    </h3>
                                    <ul className="ml-7 list-disc">
                                        {analysisResults.recommendations.dos.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="animate-text">
                                    <h3 className="mb-1 font-bold flex items-center gap-2">
                                        <span className="text-red-500 text-sm">
                                            <img src={CrossMark} alt="cross" className="w-4 h-4 mb-neg" />
                                        </span> {t.donts}:
                                    </h3>
                                    <ul className="ml-7 list-disc">
                                        {analysisResults.recommendations.donts.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            </>
                        )}
                    </div>
                    
                    <div className="border-top p-4">
                        <h3 className="mb-1 font-bold">
                            {isRecruiterMode ? t.teamFit : t.bestWorkCulture}
                        </h3>
                        <p className="animate-text">{analysisResults.recommendations.bestWorkCulture}</p>
                    </div>
                    
                    <div className="border-top p-4">
                        <h3 className="mb-1 font-bold">
                            {isRecruiterMode ? t.potentialChallenges : t.developmentPoints}
                        </h3>
                        <ul className="ml-7 list-disc">
                            {analysisResults.recommendations.developmentPoints.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    
                    {isRecruiterMode && (
                        <div className="border-top p-4">
                            <h3 className="mb-1 font-bold">{t.interviewFocusAreas}</h3>
                            <p className="mb-2">{t.interviewFocusDescription}</p>
                            <ul className="ml-7 list-disc">
                                {analysisResults.recommendations.interviewFocusAreas?.map((area, index) => (
                                    <li key={index}>{area}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Recommendations;